"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Join: function() {
        return Join;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Join = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14 18C14.47 18 14.93 17.96 15.37 17.88C14.28 20.31 11.84 22 9 22C5.13 22 2 18.86 2 15C2 12.16 3.69 9.71 6.12 8.62C6.04 9.07 6 9.53 6 10C6 14.42 9.58 18 14 18Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M16 15C16 15.42 15.96 15.83 15.89 16.22C15.29 16.4 14.66 16.5 14 16.5C10.41 16.5 7.5 13.59 7.5 10C7.5 9.34 7.6 8.71 7.78 8.11C8.17 8.04 8.58 8 9 8C12.87 8 16 11.13 16 15Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M14 2C10.05 2 6.77 4.86 6.12 8.62C6.64 8.38 7.2 8.21 7.78 8.11C8.59 5.44 11.07 3.5 14 3.5C17.59 3.5 20.5 6.41 20.5 10C20.5 12.93 18.56 15.41 15.89 16.22C15.79 16.8 15.62 17.36 15.37 17.88C19.14 17.23 22 13.95 22 10C22 5.58 18.42 2 14 2Z",
            fill: "currentColor"
        })
    ]
}), "Join");
const _default = Join;
